export const GITHUB_SHA: string | undefined = import.meta.env.GITHUB_SHA;
